import React from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Hero } from './components/Hero';
import { StatsStrip } from './components/StatsStrip';
import { WhyAutopoint } from './components/WhyAutopoint';
import { WeHandleEverything } from './components/WeHandleEverything';
import { HowItWorks } from './components/HowItWorks';
import { SocialProof } from './components/SocialProof';
import { MidCTA } from './components/MidCTA';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { SellForm } from './components/SellForm';
import { ContactSection } from './components/ContactSection';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { HelpBubble } from './components/HelpBubble';
export function App() {
  return <div className="min-h-screen bg-white font-heading" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <StatsStrip data-id="element-4" />
        <WhyAutopoint data-id="element-5" />
        <WeHandleEverything data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <SocialProof data-id="element-8" />
        <MidCTA data-id="element-9" />
        <FAQ data-id="element-10" />
        <FinalCTA data-id="element-11" />
        <SellForm data-id="element-12" />
        <ContactSection data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <StickyMobileCTA data-id="element-15" />
      <HelpBubble data-id="element-16" />
    </div>;
}